import type { SensitiveContentModel } from '@/adapters/apiv1.g';
import type { SensitiveContent } from '@/types/core/sensitive-content';
import type { UUID } from '@/utils/uuid';

export function extractSensitiveContent(
  data: SensitiveContentModel
): SensitiveContent {
  return {
    id: data.id ?? '',
    connectorId: (data.connector_id ?? '') as UUID,
    connectorName: data.connector_name ?? '',
    featureId: (data.feature_id ?? '') as UUID,
    featureName: data.feature_name ?? '',
    runSequence: data.run_sequence ?? 0,
    collectedAt: data.collected_at ?? '',
    expiresAt: data.expires_at ?? '',
    templateName: data.template_name ?? '',
    templateMismatch: data.template_mismatch ?? false,
    sizeBytes: data.size_bytes ?? 0,
  };
}
